module.exports = __webpack_public_path__ + "img/sponsor-carousel-daphne.38399252.jpg";